const CartSvg = ({
  height = 18,
  width = 18,
  viewBox = '0 0 18 18',
  stroke = '#7C7E8C',
  fill = '#7C7E8C',
  className = '',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  stroke?: any;
  fill?: any;
  className?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" className={className}>
      <path
        d="M12.75 15C12.75 15.4142 13.0858 15.75 13.5 15.75C13.9142 15.75 14.25 15.4142 14.25 15C14.25 14.5858 13.9142 14.25 13.5 14.25C13.0858 14.25 12.75 14.5858 12.75 15Z"
        fill={fill}
      />
      <path
        d="M5.25 15C5.25 15.4142 5.58579 15.75 6 15.75C6.41421 15.75 6.75 15.4142 6.75 15C6.75 14.5858 6.41421 14.25 6 14.25C5.58579 14.25 5.25 14.5858 5.25 15Z"
        fill={fill}
      />
      <path
        d="M2.25 2.25H2.45126C2.80659 2.25 2.98457 2.25 3.1295 2.31411C3.25728 2.37063 3.36653 2.46163 3.44531 2.57703C3.53452 2.70769 3.56673 2.88217 3.63103 3.23045L5.25003 12L13.0664 12C13.4063 12 13.5767 12 13.7175 11.9399C13.8419 11.8869 13.9491 11.801 14.0288 11.6917C14.1189 11.5682 14.1571 11.4028 14.2333 11.0723L15.4108 5.96997C15.5267 5.46762 15.5847 5.21637 15.5211 5.01929C15.4652 4.84637 15.3476 4.69976 15.1917 4.60644C15.0138 4.5 14.7568 4.5 14.2415 4.5H4.125"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CartSvg;
